/** @format */
import { Link, LinkSize } from '@mpb-com/feather/components/atoms/link';
import { useTranslation } from 'next-i18next';
import React from 'react';

export const SectionTitleChildNode = ({
    isOpen,
    onClearAll,
    selectedCount,
}: {
    isOpen: boolean;
    selectedCount: number;
    onClearAll: () => void;
}) => {
    const { t } = useTranslation();

    if (selectedCount === 0) {
        return null;
    }

    if (!isOpen) {
        return (
            <span className="extra-node-count">
                {t('{{count}} selected', { count: selectedCount })}
            </span>
        );
    }

    return (
        <Link
            size={LinkSize.SMALL}
            className="extra-node-clear"
            onClick={onClearAll}
        >
            {t('Clear all')}
        </Link>
    );
};
